import { defineStore } from "pinia";

export interface State {
  ConsigneePoIdList: any[];
}

export const useConsigneeStore = defineStore({
  id: "ConsigneeStore",

  state: (): State => ({
    ConsigneePoIdList: [],
  }),

  getters: {},
  actions: {
    isReset() {},
    isResetall() {},
    isResetBool() {},
  },
});
